<template>
  <v-autocomplete
    v-bind="$attrs"
    ref="autocomplete"
    :loading="loading"
    v-model="itemValue"
    :items="computedItems"
    :search-input.sync="search"
  >
    <template v-slot:no-data>
      <slot name="no-data"></slot>
    </template>

    <template v-slot:item="{ item }">
      <slot name="item" v-bind:item="item"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: "async-autocomplete",
  inheritAttrs: false,
  props: {
    value: null,
    url: String,
    queries: String,
    resetOnBlur: {
      type: Boolean,
      default: false,
    },
    appendItem: {
      default: false,
    },
    editAppend: {
      default: false,
    },
  },
  data() {
    return {
      items: [],
      search: "",
      loading: false,
    };
  },
  computed: {
    computedItems() {
      let items = this.items;
      if (this.appendItem && this.editAppend)
        return [this. appendItem, this.editAppend, ...items];
      else if (this.appendItem) return [this.appendItem, ...items];
      else if (this.editAppend) return [this.editAppend, ...items];
      else return items;
    },
    itemValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        let item = this.computedItems.find((x) => x.id == val) || {};
        this.$emit("change", val);
        this.$emit("setItem", item);
      },
    },
  },
  watch: {
    search: debounce(function (oldval, newVal) {
      oldval = oldval && oldval.trim();
      newVal = newVal && newVal.trim();
      if (oldval == newVal && oldval.length >0) return;

      this.search = this.search && this.search.trim();

      if (!this.search || this.search.length == 0) return;
      this.loading = true;

      this.axios
        .get(
          `${this.url}?search=${encodeURIComponent(this.search)}&${
            this.queries
          }`
        )
        .then(({ data }) => {
          this.loading = false;
          this.items = data.data ? data.data : data;
        })
        .catch(() => {
          this.loading = false;
        });
    }, 500),
  },
  methods: {
    clear() {
      this.items = [];
    },
  },
  created() {
    this.clear();
  },
};
</script>